import { connect } from 'react-redux'
import ListInfos from './ListInfos'

const mapStateToProps = state => ({
  stock: state.stock
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListInfos)
